import React from 'react';
import ReactSelectize from 'react-selectize';
import { partitionString } from 'prelude-extension';

class TypeReference extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.reference) {
            const id = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'Id').contentValue;
            let name = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'DeveloperName').contentValue;
            let service = manywho.utils.getObjectDataProperty(this.props.reference.properties, 'ServiceElementDeveloperName');

            if (!manywho.utils.isNullOrWhitespace(this.props.search) && name.substr(0, 1) !== '$')
                name = <ReactSelectize.HighlightedText
                        partitions = {partitionString(name.toUpperCase(), this.props.search.toUpperCase())}
                        text = {name}
                        highlightStyle = {{
                            backgroundColor: "rgba(255,255,0,0.4)",
                            fontWeight: "bold"
                        }}
                    />;
            else
                name = <span className="value-reference-name">{name}</span>;

            if (service)
                service = service.contentValue;

            return <div key={id}>
                <div className="value-reference" onClick={this.props.onClick} key={'reference-' + this.props.reference.externalId}>
                    {name}
                    <span className="value-reference-details">{service}</span>              
                </div>
                 {(this.props.isSelected) ? <span className="glyphicon glyphicon-ok" title="Selected"/> : null}
            </div>;
        }

        return null;
    }
}

export default TypeReference;
